// extracted by mini-css-extract-plugin
export default {"builder-column":"client-components-schemaDetail-schemaBuilder-___schemaBuilder__builder-column___32yEN"};